// Single source of truth for the Copy API model dropdown (config page + test
// page) and the server-side allowlist used to validate the test override.
//
// OpenAI models use our cheerio scraper for website context. Claude and Gemini
// models fetch the sponsor URL themselves (web fetch / URL context).
export const COPY_API_MODELS = [
  { value: "gpt-5.2", label: "GPT-5.2 (OpenAI, scrape)" },
  { value: "gpt-5-mini", label: "GPT-5 Mini (OpenAI, scrape)" },
  { value: "gpt-5-nano", label: "GPT-5 Nano (OpenAI, scrape)" },
  { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6 (web fetch)" },
  { value: "claude-opus-4-8", label: "Claude Opus 4.8 (web fetch)" },
  { value: "gemini-2.5-pro", label: "Gemini 2.5 Pro (URL context)" },
  { value: "gemini-2.5-flash", label: "Gemini 2.5 Flash (URL context)" },
] as const;

// Plain string[] for membership checks (validation on the test route).
export const COPY_API_MODEL_VALUES: string[] = COPY_API_MODELS.map((m) => m.value);
